import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsAddTagBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Add post tag</div>
          <div className="text">
            Adds a tag to a post. Both post and tag are specified by their unique id.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The post's unique identifier.",
                heading: 'postID',
                subheading: 'string',
              },
              {
                description: "The tag's unique identifier.",
                heading: 'tagID',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns the updated post if the tag was successfully added.</div>
          <div className="text">
            <div className="emphasize">Note:</div> If you try to add a tag that has already been
            added, the endpoint will still respond with the updated post, even though no tag has
            been added.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/posts/add_tag</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/posts/add_tag"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d postID=553c3ef8b8cdcd1501ba1238
    -d tagID=553c3ef8b8cdcd1501ba12bb`}
          />
          <div className="text">Example Responses</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1238",
  "author": {
    "id": "553c3ef8b8cdcd1501ba123a",
    "created": "2017-07-15T22:11:00.000Z",
    "email": "test@test.test",
    "isAdmin": false,
    "name": "Sally Doe",
    "url": "https://your-company.canny.io/admin/users/sally-doe",
    "userID": "1234"
  },
  "board": {
    "created": "2017-07-10T11:22:00.000Z",
    "id": "553c3ef8b8cdcd1501ba1234",
    "name": "Feature Requests",
    "postCount": 123,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "by": {
    "id": "524c3ef8b8cdcd1501ba246b",
    "created": "2017-07-15T22:11:00.000Z",
    "email": "test@john.test",
    "isAdmin": true,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "5678"
  },
  "category": {
    "id": "553c3ef8b8cdcd1501ba2234",
    "name": "Dashboard",
    "parentID": null,
    "postCount": 42,
    "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
  },
  "changeComment": {
    "value": "The status has changed!",
    "imageURLs": ["https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b2.png"]
  },
  "clickup": {
    "linkedTasks": [{
      "id": "123",
      "linkID": "2334jdsai23234io22",
      "name": "Clickup issue",
      "postID": "553c3ef8b8cdcd1501ba1238",
      "status": "to do",
      "url": "https://app.clickup.com/t/123456"
    }]
  },
  "commentCount": 10,
  "created": "2017-08-22T13:32:00.000Z",
  "details": "Test post details",
  "eta": "February 2020",
  "imageURLs": [
    "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
    "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
  ],
  "jira": {
    "linkedIssues": [{
      "id": "123",
      "key": "ID-123",
      "url": "https://your-company.atlassian.net/browse/ID-123"
    }]
  },
  "linear": {
    "linkedIssueIDs": ["ID-123", "ID-345"],
  },
  "mergeHistory":[{
    "created":"2018-06-17T22:42:37.167Z",
    "post": {
      "created":"2018-06-17T22:42:00.797Z",
      "details":"Awesome feature post details",
      "id": "553c3ef8b8cdcd1501ba6789",
      "imageURLs":[],
      "title":"Another awesome feature request"
    }
  }],
  "score": 72,
  "status": "in progress",
  "statusChangedAt": "2017-08-24T23:22:00.000Z",
  "tags": [{
    "board": {
      "created": "2017-07-10T11:22:00.000Z",
      "id": "553c3ef8b8cdcd1501ba1234",
      "name": "Feature Requests",
      "postCount": 123,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "created": "2017-08-30T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba3234",
    "name": "iOS",
    "postCount": 15,
    "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
  }, {
    "board": {
      "created": "2017-07-10T11:22:00.000Z",
      "id": "553c3ef8b8cdcd1501ba1234",
      "name": "Feature Requests",
      "postCount": 123,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "created": "2018-04-20T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba12bb",
    "name": "Example Tag",
    "postCount": 12,
    "url": "https://your-company.canny.io/admin/board/feature-requests?tags=example-tag"
  }],
  "title": "An awesome feature request",
  "url": "https://your-company.canny.io/admin/board/feature-requests/p/an-awesome-feature-request"
}`}
          </Highlight>
          <Highlight lang="json">{'{"error":"invalid post id"}'}</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
